import * as React from "react";
import {useEffect, useState} from 'react';

import "./news.css"
import {DealerNewsEditModal} from "./News/EditModal";
import {Translations} from "../../translations/Translations";
import {
    DealerNewsCollection,
    DealerNewsEntity,
    DealerNewsService
} from "../../services/DealerNews";
import {LoaderSpinner} from "../LoaderSpinner";
import {DealerNewsDeleteModal} from "./News/DeleteModal";
import {MetaField, MetaFieldDescription, MetaFieldGroup} from "./News/MetaFields";

type DealerNewsProps = {
    trn: Translations,
    dealer_id: number,
    category: string,
    meta_fields: MetaFieldGroup[],
    table_cols: { label: string, field: string }[],
    lang: string,
}

export const DealerNews = ({trn, dealer_id, category, meta_fields, table_cols, lang}: DealerNewsProps) => {

    const [editFormVisible, setEditFormVisible] = useState(false);
    const [deleteFormVisible, setDeleteFormVisible] = useState(false);

    const [list, setList] = useState<DealerNewsCollection>([]);
    const [loading, setLoading] = useState(true);
    const [newsToEdit, setNewstoEdit] = useState<DealerNewsEntity>(null);

    const service = new DealerNewsService(dealer_id, category, lang, meta_fields);

    useEffect(() => {
        updateList();
    }, []);

    const updateList = () => {
        service.getList().then((list) => {
            setList(list);
            setLoading(false)
        });
    }

    const editNews = (news: DealerNewsEntity) => {
        setNewstoEdit(news);
        setEditFormVisible(true);
    }

    const createNewEntry = () => {
        let news: DealerNewsEntity = {
            title: '',
            content: '',
            date: '',
            picture: null,
            picture_url: null,
        }
        setNewstoEdit(news);
        setEditFormVisible(true);
    }

    const saveNews = (news: DealerNewsEntity) => {
        setEditFormVisible(false);
        setLoading(true);

        if (news.post_id) {
            service.update(news).then(() => updateList());
        } else {
            service.create().then(id => {
                setTimeout(() => {
                    news.post_id = id;
                    service.update(news).then(() => updateList());
                }, 100);
            });
        }
    }

    const deleteNews = (news: DealerNewsEntity) => {
        setNewstoEdit(news);
        setDeleteFormVisible(true);
    }

    const deleteNewsConfirm = (news: DealerNewsEntity) => {
        setDeleteFormVisible(false);
        setLoading(true);
        service.delete(news).then(() => updateList());
    }

    const getMetaFieldValue = (news: DealerNewsEntity, metaFieldName: string): string => {
        let returnValue = ''
        JSON.parse(news.meta_fields).map((metaField: MetaField) => {
            if (metaField.name == metaFieldName) {
                returnValue = metaField.value;
            }
        });

        if (metaFieldName == 'title' || metaFieldName == 'date') {
            let k: keyof typeof news;
            for (k in news) {
                if (k == metaFieldName) {
                    return news[k];
                }
            }
        }

        return returnValue;
    }

    return <div className={"dealer-news"}>

        <DealerNewsEditModal metaFieldGroups={meta_fields} news={newsToEdit}
                             onSave={(news: DealerNewsEntity) => saveNews(news)} trn={trn}
                             editFormVisible={editFormVisible} onCloseRequest={() => setEditFormVisible(false)}/>
        <DealerNewsDeleteModal news={newsToEdit} onCloseRequest={() => setDeleteFormVisible(false)} trn={trn}
                               deleteFormVisible={deleteFormVisible} onDelete={(news) => deleteNewsConfirm(news)}/>

        {loading &&
            <LoaderSpinner/>
        }

        {!loading &&
            <React.Fragment>
                <a style={{margin: '10px 0'}} className={"button"}
                   onClick={() => createNewEntry()}>{trn.createNewEntry}</a>

                <table className={"wp-list-table widefat fixed striped table-view-list"}
                       style={{border: "transparent"}}>
                    <thead>
                    <tr>
                        {table_cols.map(table_col => {
                            return <th scope="col" className="manage-column">{table_col.label}</th>
                        })}
                        <th style={{width: '75px'}} scope="col" className="manage-column"/>
                        <th style={{width: '75px'}} scope="col" className="manage-column"/>
                    </tr>
                    </thead>
                    <tbody>
                    {list.map(entry => {
                        return <tr>
                            {table_cols.map(table_col => {
                                return <td>{getMetaFieldValue(entry, table_col.field)}</td>
                            })}
                            <td><a onClick={() => editNews(entry)}>{trn.edit}</a></td>
                            <td><a onClick={() => deleteNews(entry)}>{trn.delete}</a></td>
                        </tr>
                    })}
                    </tbody>
                </table>
            </React.Fragment>
        }
    </div>;
}